export default __webpack_public_path__ + "static/media/8osissf.533b01bd.webp";